export default __webpack_public_path__ + "static/media/notes.0138310d.svg";